//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { has } from "lodash";
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
import { sortBy } from "lodash";
import * as VocabularyActions from './actions';
import axios from 'axios';
import configInfo from "config"
import { validateObjectData } from 'utils/methods/math';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create vocabulary --------------------
const onFilterVocabularyStd = (bookVocabulary, bookId, pageId, currentUser) => {
    // const filterVocab = filter(bookVocabulary, obj => obj.chapter == bookId && obj.page == pageId && obj.created_by == 'student' && obj.user_id == currentUser);
    let sorted_obj = sortBy(bookVocabulary,
        [
            function (o) {
                // Ensuring the property exists and is a string
                if (o.data && typeof o.data.word === 'string') {
                    // Converting to lowercase for case-insensitive comparison
                    return o.data.word.toLowerCase();
                }
                return ''; // Default value in case the property doesn't exist
            }
        ]);
    return sorted_obj;
}
export const handleCreateVocabulary = (data,currentUserRole) => async (dispatch) => {
    await dispatch(VocabularyActions.createVocabulary());
    try {
        const vocabularyData = await apis.post('vocabularyRDS', `/addVocabulary`, {
            body: data
        });
        if (data.id) {
            if(data?.isAdminOne && currentUserRole === 'teacher'){
                await dispatch(VocabularyActions.createVocabularySuccess(vocabularyData));
                return vocabularyData;
            }
            await dispatch(VocabularyActions.updateVocabularySuccess(vocabularyData));
        } else {
            await dispatch(VocabularyActions.createVocabularySuccess(vocabularyData));
        }
        return vocabularyData
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating vocabulary',
                error,
                module: 'VOCABULARY',
                operation: 'CREATE_VOCABULARY'
            });
        }
    }
};

export const handleGetAiOptionForAnswer = (payload) => async (dispatch) => {
    try {
      const data = await apis.post("vocabularyRDS", `/ai_fill_up_question`, {
        body: payload
      });
      return data;
    } catch (error) {
      if (error && error.message != "Network Error") {
        logToSentry({
                message: 'getting ai option for answer',
                error,
                module: 'VOCABULARY',
                operation: 'GET_ACTIVITY_ORGANIZATION_FEEDBACK_ACTIVITY'
            });
      }
    }
  };

//  -- List vocabulary ----------------
export const handleListVocabularyNew = (data, bookId, pageId, currentUser) => async (dispatch) => {
    try {
        const vocabularyRDS = await apis.post('vocabularyRDS', `/listVocabulary`, {
            body: data
        });
        let vocabularyupdatasort = onFilterVocabularyStd(vocabularyRDS, bookId, pageId, currentUser)
        await dispatch(VocabularyActions.listVocabularySuccess(vocabularyupdatasort));


        return vocabularyRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing vocabulary',
                error,
                module: 'VOCABULARY',
                operation: 'LIST_VOCABULARY'
            });
        }
    }
};

export const handleListVocabularyStud = (data, bookId, pageId, currentUser) => async (dispatch) => {
    try {
        const vocabularyRDS = await apis.post('vocabularyRDS', `/listVocabulary`, {
            body: data
        });
        return vocabularyRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing vocabulary student',
                error,
                module: 'VOCABULARY',
                operation: 'LIST_VOCABULARY_STUDENT'
            });
        }
    }
};

export const handleGetStudentWordCount = (data) => async (dispatch) => {
  try {
    const studentWordCounts = await apis.post('vocabularyRDS', `/getStudentWordCount`, {
      body: data,
    });

    if (Array.isArray(studentWordCounts)) {
      return studentWordCounts;
    }
  } catch (error) {
    if (error && error.message != 'Network Error') {
      logToSentry({
                message: 'Error getting student word count',
                error,
                module: 'VOCABULARY',
                operation: 'EXPORT_GRADE_STUDENT_WORKSHEET_CONTENT'
            });
    }
  }
};

export const setDataVocabular = (data) => async (dispatch) => {
    await dispatch(VocabularyActions.listVocabularySuccess(data));


}
// function parseResponse(responseString) {
//     const cleanedString = typeof responseString === "string"?responseString.replace(/```json\n|\n```|\\n/g, ''):null;
//     if(typeof responseString === "object" && Object.keys(responseString).length>0) return responseString;
//     try {
//         return JSON.parse(cleanedString);
//     } catch (error) {
//         logToSentry({
            //     message: '1138 Failed to parse response',
            //     error,
            //     module: 'VOCABULARY',
            //     operation: 'FETCH_TEACHER_PREFERENCE_RESOURCE'
            // });
//         console.error("Failed to parse response:", error);
//         return null; // or handle the error as you see fit
//     }
// }
//  -- Create vocabulary AI --------------------
export const handleCreateVocabularyAI = (data) => async (dispatch) => {
    try {
        const vocabularyData = await apis.post('vocabularyRDS', `/vocabulary_ai`, {
            body: data
        });
        // return parseResponse(vocabularyData)
        if (vocabularyData && vocabularyData.id) {
            const checkValidData = validateObjectData(vocabularyData?.data);  
            if(!checkValidData?.valid){
                return {valid:false,...vocabularyData};
            }
            await dispatch(VocabularyActions.createVocabularySuccess({...vocabularyData, valid: true}));
        }
        return {valid:true,...vocabularyData};
    } catch (error) {
        if (error) {
            logToSentry({
                message: 'creating vocabulary ai',
                error,
                module: 'VOCABULARY',
                operation: 'CREATE_VOCABULARY_ACTIVITY'
            });
            return null;
        }
    }
};
export const handleGenerateVocabularyWithAI = (data, initalAttempt=0,maxAttempt=1,showAlert) => async (dispatch) => {
    try {
        const vocabularyData = await apis.post('vocabularyRDS', `/generate_vocabulary`, {
            body: data
        });

        if(vocabularyData?.id){
            const checkValidData = validateObjectData(vocabularyData?.data);  
            if(!checkValidData?.valid){
                return {valid:false,...vocabularyData};
            }
         await dispatch(VocabularyActions.createVocabularySuccess({...vocabularyData, valid: true}));
        }
       
        return {isValid:true,...vocabularyData};
    } catch (error) {
        if (error) {
            logToSentry({
                message: 'generating vocabulary with ai',
                error,
                module: 'VOCABULARY',
                operation: 'GET_VOCABULARY_WORKSHEET_ACTIVITY'
            });
            return null;
        }
    }
};

export const handleGenerateVocabularyWithMode = (data) => async (dispatch) => {
    try {
        const vocabularyData = await apis.post('vocabularyRDS', `/generate_vocabulary_with_mode`, {
            body: data
        });
        if (vocabularyData && vocabularyData.id) {
            const requiredFields = [
            'antonyms_in_english',
            'antonyms_in_spanish',
            'definition',
            'english_translation',
            'mode',
            'sentence_in_english',
            'sentence_in_spanish',
            'synonyms_in_english',
            'synonyms_in_spanish',
            'word'
        ];
            const checkValidData = validateObjectData(vocabularyData?.data,requiredFields);  
            if(!checkValidData?.valid){
                return {valid:false,...vocabularyData};
            }
            await dispatch(VocabularyActions.createVocabularySuccess({...vocabularyData, valid: true}));
        }
        return {valid:true,...vocabularyData};
    } catch (error) {
        if (error) {
            logToSentry({
                message: 'generating vocabulary with mode',
                error,
                module: 'VOCABULARY',
                operation: 'GET_VOCABULARY_WORKSHEET_MESSAGE'
            });
            return null;
        }
    }
};


//  -- List vocabulary ----------------
export const handleListVocabulary = ( bookId, pageId, currentUser) => async (dispatch) => {
    try {
        const vocabularyRDS = await apis.get('vocabularyRDS', `/getVocabulary`);
        let vocabularyupdatasort = onFilterVocabularyStd(vocabularyRDS, bookId, pageId, currentUser)


        await dispatch(VocabularyActions.listVocabularySuccess(vocabularyupdatasort));
        return vocabularyRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing vocabulary',
                error,
                module: 'VOCABULARY',
                operation: 'LIST_VOCABULARY'
            });
        }
    }
};


//  -- Delete Book vocabulary ----------
export const handleDeleteVocabulary = (id) => async (dispatch) => {
    if (!id) return;
    dispatch(VocabularyActions.deleteVocabulary())
    try {
        const vocabulary = await apis.del('vocabularyRDS', `/deleteVocabulary/${id}`);
        if (has(vocabulary, "id")) {
            await dispatch(VocabularyActions.deleteVocabularySuccess(vocabulary));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting vocabulary',
                error,
                module: 'VOCABULARY',
                operation: 'DELETE_VOCABULARY'
            });
        }
    }
};


export const handleIdeaFeach = async (topic) => {
    try {
        const data = await apis.post('vocabularyRDS', `/idea`, {
            body: { topic }
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'fetching idea',
                error,
                module: 'VOCABULARY',
                operation: 'FETCH_INSTRUCTION'
            });
        }
    }
};


export const handleTextToSpeech = async (datas) => {
    try {
        const data = await apis.post('firebase', `/text_to_speach_token`, {
            body: datas 
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'text to speech',
                error,
                module: 'VOCABULARY',
                operation: 'TEST_TEACHER_STUDENT'
            });
        }
    }
};
export const handleTextToSpeechWithEleven = async (datas) => {
    try {
        const data = await apis.post('firebase', `/elevenlabTextToSpeach`, {
            body: datas 
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'text to speech',
                error,
                module: 'VOCABULARY',
                operation: 'TEST_TEACHER_STUDENT'
            });
        }
    }
};





//  -- Create vocabulary AI generated QnA --------------------
export const handleCreateVocabularyAIQnA = (data) => async (dispatch) => {
    try {
        const vocabularyData = await apis.post('vocabularyRDS', `/vocabular_ai_QnA`, {
            body: data
        });
        return vocabularyData;
    } catch (error) {
        if (error) {
            logToSentry({
                message: 'creating vocabulary ai qna',
                error,
                module: 'VOCABULARY',
                operation: 'CREATE_VOCABULARY_ACTIVITY_QUIZ'
            });
            return null;
        }
    }
};

//  -- AI Content Store Update --------------------
export const handleAiContentStoreUpdate = (data) => async (dispatch) => {
    try {
        const vocabularyData = await apis.post('vocabularyRDS', `/ai_content_store_update`, {
            body: data
        });
        return vocabularyData;
    } catch (error) {
        if (error) {
            logToSentry({
                message: 'ai content store update',
                error,
                module: 'VOCABULARY',
                operation: 'ADD_CLASS_STUDENT_USER'
            });
            return null;
        }
    }
};

export const handleQuestionAudioWorkSheet = async (datas) => {
    try {
        const data = await apis.post('firebase', `/audio_for_worksheet`, {
            body: datas 
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'VOCABULARY',
                operation: 'CREATE_VOCABULARY'
            })
        }
    }
};

export const handleQuestionMediaWorkSheet = async (datas) => {
    try {
        const data = await apis.post('vocabularyRDS', `/worksheet/regenerate_image_ai`, {
            body: datas 
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'VOCABULARY',
                operation: 'GET_AI_OPTION_FOR_ANSWER'
            })
        }
    }
};
export const handleElevenLabsWithAudio = async (datas) => {
    try {
        const data = await apis.post('firebase', `/regenerate_eleven_labs`, {
            body: datas 
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'text to speech',
                error,
                module: 'VOCABULARY',
                operation: 'TEST_TEACHER_STUDENT'
            });
        }
    }
};


//  -- Create story AI generated QnA --------------------

export const handleGenerateWrongAnswerFeedBack = async (datas) => {
    try {
        const data = await apis.post('vocabularyRDS', `/regenerate_wrong_answer_feedback`, {
            body: datas 
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'VOCABULARY',
                operation: 'GENERATE_WRONG_ANSWER_FEEDBACK'
            })
            return null;
        }
        return null;
    }
};

export const handleGeneratePronounDetails = async (datas) => {
    try {
        const data = await apis.post('vocabularyRDS', `/regenerate_pronoun_detail`, {
            body: datas 
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error in operation',
                error,
                module: 'VOCABULARY',
                operation: 'GENERATE_PRONOUN_DETAILS'
            })
        }
        return null;
    }
};